export const PAGE_SIZE_OPTIONS: number[] = [20, 50, 100, 500];
export const ERROR_MSG_DURATION = 6000;
export const SUCCESS_MSG_DURATION = 3000;
